import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { css } from "@mui/material/styles";
import { NavLink } from "react-router-dom";
import {
  COLOR_WHITE,
  COLOR_PRIMARY_MAIN,
  COLOR_SECONDARY_MAIN,
} from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledNavItemLink = styled(NavLink, {
  shouldForwardProp: (propName) =>
    !["active", "iconColor", "expanded"].includes(propName),
})<{
  active: boolean;
  iconColor?: string;
  expanded?: boolean;
}>`
  ${flex({ ai: "center", jc: "space-between" })}
  width: ${({ expanded }) => (expanded ? "auto" : "max-content")};
  padding: 0.75rem;
  cursor: pointer;
  border-radius: 0.5rem;
  text-decoration: none;
  height: 40px;
  box-sizing: border-box;

  ${({ iconColor }) => css`
    :hover {
      .MuiTypography-root {
        color: ${COLOR_WHITE};
      }

      svg > path {
        fill: ${iconColor || COLOR_WHITE};
      }
    }
  `}

  ${(props) =>
    props.active &&
    css`
      background-color: ${COLOR_PRIMARY_MAIN};

      svg > path {
        fill: ${COLOR_WHITE};
      }
    `}
`;

export const StyledBox = styled(Box)`
  ${flex()};
`;

export const StyledChip = styled(Box)`
  ${flex({ ai: "center", jc: "center" })};
  background-color: ${COLOR_SECONDARY_MAIN};
  height: 1.5rem;
  border-radius: 0.75rem;
  min-width: 24px;
`;
